import React from 'react';
import classNames from 'classnames';
import css from './SkeletonLoader.module.scss';

export type SkeletonLoaderProps = {
  className?: string;
  type: 'text' | 'title' | 'avatar' | 'button' | 'rect';
  width?: number | string;
  widthFromTo?: [number, number];
};

const getRandomWidth = (from: number, to: number) => {
  return Math.floor(Math.random() * (to - from + 1)) + from;
};

export const SkeletonLoader = ({
  type,
  width,
  widthFromTo,
  className,
}: SkeletonLoaderProps) => {
  let loaderWidth = width;

  if (!loaderWidth && widthFromTo) {
    loaderWidth = getRandomWidth(widthFromTo[0], widthFromTo[1]);
  }

  return (
    <div className={classNames(css.root, className)}>
      {type === 'text' && (
        <div className={css.text} style={{width: loaderWidth}} />
      )}

      {type === 'title' && (
        <div className={css.title} style={{width: loaderWidth}} />
      )}

      {type === 'avatar' && (
        <div className={css.avatar} style={{width: loaderWidth}} />
      )}

      {type === 'button' && (
        <div className={css.button} style={{width: loaderWidth}} />
      )}

      {type === 'rect' && (
        <div className={css.rect} style={{width: loaderWidth}} />
      )}
    </div>
  );
};
